import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {arrayIsSet, GlobalVariablesService} from "../../../providers/service/global-variables.service";


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnChanges {

    @Input() currentUrl: string = '';

    @Input() disabledMenu = false;
    // disabledProject = false;

    // public iconLanguage = 'it';
    // public darkModeOn = (this.localStorage.darkModeOn == null) ? true : this.localStorage.darkModeOn;
    @Input() links: any[] = []
    @Input() toRead: boolean | null = false;
    @Input() isTest: boolean | null = false;


// {
//     path: '/',
//     roleRoVisualized: undefined,
//     iconCustom: 'assets/icon/hamburgerNavbar/version.png',
//     title: this.globalVariable.versionSoftware
// }
    isSystemAdmin$

    constructor(
        private globalVariable: GlobalVariablesService,
    ) {
        this.isSystemAdmin$ = this.globalVariable.isSystemAdmin$;
    }


    // get versioneSoftware(){
    //     return this.globalVariable.versionSoftware
    // }
    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (isNotNullOrUndefined(changes.currentUrl)) {
        //     const disableButtonUrls = ['/project']
        //     if (disableButtonUrls.includes(this.currentUrl)) {
        //         this.disabledMenu = true;
        //         // this.disabledProject = true;
        //     } else {
        //         this.disabledMenu = false;
        //         // this.disabledProject = false;
        //     }
        // }
    }

    // logout() {
    //     this.userService.logout();
    //     this.localStorage.removeAllProjectItems();
    // }
    //
    // get nameUser() {
    //     return (this.userService.user) ? this.userService.user.get('nome') : null;
    // }
    //
    //
    // setLanguage(language: string) {
    //     if (this.translate.getLangs().includes(language)) {
    //         this.translate.use(language);
    //         this.iconLanguage = language;
    //     }
    // }
    //
    // public darkModeChangeValue(checked: boolean) {
    //     this.darkModeOn = checked;
    //     this.localStorage.darkModeOn = this.darkModeOn;
    //     const theme = (this.darkModeOn) ? "dark-theme" : "light-theme";
    //     this.changeTheme(theme);
    // }

    // changeTheme(theme: string) {
    //     this.themingService.theme.next(theme);
    // }

    onClickNav() {
        console.log("click");
    }

    // get allProject() {
    //     return this.globalVariable.allProject;
    // }

    get nameProject() {
        return this.globalVariable.currentProject?.name;
    }

    // selectProject(progetto: ProgettiParse) {
    //     this.localStorage.projectId = progetto.objectId;
    // }

    getUrlLogo() {
        return this.globalVariable.logoProjects
    }

    visualizedByRole(keys: string[] | undefined): boolean | undefined {
        if (Array.isArray(this.globalVariable.userRole)) {
            if (keys && arrayIsSet(keys)) {
                return keys.findIndex(key => this.globalVariable.userRole?.includes(key)) >= 0
            } else {
                return true;
            }
        }
        return undefined
    }

    getColorIconNotificationsPredicate(link: any, toRead: boolean): undefined | 'warn' {
        if (link && link.path == '/notifications' && toRead) {
            return 'warn'
        }
        return undefined
    }
}
